"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.databaseBlobCellKeys = databaseBlobCellKeys;
exports.databaseBlockBlobCellKeys = databaseBlockBlobCellKeys;
exports.addBlobId = addBlobId;
exports.collectDatabaseRowBlobIds = collectDatabaseRowBlobIds;
exports.collectDatabaseCellBlobIds = collectDatabaseCellBlobIds;
const yjs_1 = require("yjs");
const database_column_lineage_1 = require("./database-column-lineage");
/** The blob cell keys of the defined columns (`prop:columns`, as plain values). */
function databaseBlobCellKeys(columns) {
    return {
        attachmentCellKeys: new Set((0, database_column_lineage_1.databaseCellKeysOfType)(columns, 'attachment')),
        imageCellKeys: new Set((0, database_column_lineage_1.databaseCellKeysOfType)(columns, 'image')),
    };
}
/** The blob cell keys of a database block, read from its `prop:columns`. */
function databaseBlockBlobCellKeys(block) {
    const columns = block.get('prop:columns');
    const plain = columns instanceof yjs_1.Array ? columns.toJSON() : columns;
    return databaseBlobCellKeys(Array.isArray(plain) ? plain : []);
}
/** Adds the blob a block or cell names; a leading slash is not part of it. */
function addBlobId(target, value) {
    if (typeof value !== 'string')
        return;
    const blobId = value.replace(/^\//, '');
    if (blobId)
        target.add(blobId);
}
function cellValue(cell) {
    return cell &&
        typeof cell === 'object' &&
        !Array.isArray(cell) &&
        'value' in cell
        ? cell.value
        : cell;
}
/**
 * Adds the blobs one row's file and image cells point to; `row` maps cell
 * keys to cells, as plain values. A file cell keys its files by blob ID.
 */
function collectDatabaseRowBlobIds(target, row, keys) {
    if (!row || typeof row !== 'object' || Array.isArray(row))
        return;
    const cells = row;
    for (const key of keys.attachmentCellKeys) {
        const value = cellValue(cells[key]);
        if (value && typeof value === 'object' && !Array.isArray(value))
            for (const blobId of Object.keys(value))
                addBlobId(target, blobId);
    }
    for (const key of keys.imageCellKeys)
        addBlobId(target, cellValue(cells[key]));
}
/** Adds the blobs the file and image cells of `rows` (rows by row ID) point to. */
function collectDatabaseCellBlobIds(target, rows, keys) {
    if (!rows || typeof rows !== 'object' || Array.isArray(rows))
        return;
    for (const row of Object.values(rows))
        collectDatabaseRowBlobIds(target, row, keys);
}
